import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const ReceiveScreen = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const spotCode = searchParams.get('spot_code');
        if (spotCode) {
            navigate('/bought', { replace: true });
        } else {
            navigate('/buy', { replace: true });
        }
    }, [searchParams, navigate]);
    return <></>;
};

export default ReceiveScreen;
